import type { HelpDataResponse, DraftSupplier, SupplierDetailsResponse } from "@/app/types/suppliers.types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface SuppliersState {
    helperData: HelpDataResponse | null;
    isHelperDataLoaded: boolean;
    draft: DraftSupplier | null;
    isDraftLoaded: boolean;
    draftId: string | null;
    supplierId: string | null;
    isSuppliersLoaded: boolean;
    supplierDetails: SupplierDetailsResponse | null;
    initialSupplierItems: any[] | null;
}
const initialState: SuppliersState = {
    helperData: null,
    isHelperDataLoaded: false,
    draft: null,
    isDraftLoaded: false,
    draftId: null,
    supplierId: null,
    isSuppliersLoaded: false,
    supplierDetails: null,
    initialSupplierItems: null,
}
const suppliersSlice = createSlice({
    name: "suppliers",
    initialState,
    reducers: {
        setHelperData: (state, action: PayloadAction<HelpDataResponse>) => {
            state.helperData = action.payload;
            state.isHelperDataLoaded = true;
        },
        clearHelperData: (state) => {
            state.helperData = null;
            state.isHelperDataLoaded = false;
        },
        setDraft: (state, action: PayloadAction<DraftSupplier>) => {
            state.draft = action.payload;
            state.isDraftLoaded = true;
        },
        clearDraft: (state) => {
            state.draft = null;
            state.isDraftLoaded = false;
        },
        clearDraftKeepLoaded: (state) => {
            state.draft = null;
            // Keep isDraftLoaded true to prevent re-fetching
        },
        setDraftId: (state, action: PayloadAction<string>) => {
            state.draftId = action.payload;
        },
        clearDraftId: (state) => {
            state.draftId = null;
        },
        setSupplierId: (state, action: PayloadAction<string>) => {
            state.supplierId = action.payload;
        },
        clearSupplierId: (state) => {
            state.supplierId = null;
        },
        setSuppliersLoaded: (state, action: PayloadAction<boolean>) => {
            state.isSuppliersLoaded = action.payload;
        },
        setSupplierDetails: (state, action: PayloadAction<SupplierDetailsResponse>) => {
            state.supplierDetails = action.payload;
        },
        clearSupplierDetails: (state) => {
            state.supplierDetails = null;
        },
        setInitialSupplierItems: (state, action: PayloadAction<any[]>) => {
            state.initialSupplierItems = action.payload;
        },
        clearInitialSupplierItems: (state) => {
            state.initialSupplierItems = null;
        },
    },
})
export const { setHelperData, clearHelperData, setDraft, clearDraft, clearDraftKeepLoaded, setDraftId, clearDraftId, setSupplierId, clearSupplierId, setSuppliersLoaded, setSupplierDetails, clearSupplierDetails, setInitialSupplierItems, clearInitialSupplierItems } = suppliersSlice.actions;
export const selectHelperData = (state: { suppliers: SuppliersState }) =>
    state.suppliers.helperData;
export const selectIsHelperDataLoaded = (state: { suppliers: SuppliersState }) =>
    state.suppliers.isHelperDataLoaded;
export const selectDraft = (state: { suppliers: SuppliersState }): DraftSupplier | null =>
    state.suppliers.draft;
export const selectIsDraftLoaded = (state: { suppliers: SuppliersState }) =>
    state.suppliers.isDraftLoaded;
export const selectDraftId = (state: { suppliers: SuppliersState }): string | null =>
    state.suppliers.draftId;
export const selectSupplierId = (state: { suppliers: SuppliersState }): string | null =>
    state.suppliers.supplierId;
export const selectIsSuppliersLoaded = (state: { suppliers: SuppliersState }) =>
    state.suppliers.isSuppliersLoaded;
export const selectSupplierDetails = (state: { suppliers: SuppliersState }): SupplierDetailsResponse | null =>
    state.suppliers.supplierDetails;
export const selectInitialSupplierItems = (state: { suppliers: SuppliersState }): any[] | null =>
    state.suppliers.initialSupplierItems;

export const suppliersReducer = suppliersSlice.reducer;